export default __webpack_public_path__ + "static/media/priestofmitra_icon.84861fdb.png";